import { Controller, useFormContext } from "react-hook-form";
import { z } from "zod";

import { Description, FieldError } from "@/components/ui/field";
import {
  Select,
  SelectItem,
  SelectList,
  SelectTrigger,
} from "@/components/ui/select";
import { SettingsGroupForm } from "./SettingsGroup";

const schema = z.object({
  idleTimeout: z.string().optional(),
});
type FormValues = z.infer<typeof schema>;

export function TimeoutSettings() {
  return (
    <SettingsGroupForm title="Session timeout" schema={schema}>
      <FormFields />
    </SettingsGroupForm>
  );
}

const ONE_MIN = 60_000;

const options = [
  { label: "15 minutes", value: 15 * ONE_MIN },
  { label: "30 minutes", value: 30 * ONE_MIN },
  { label: "1 hour", value: 60 * ONE_MIN },
  { label: "2 hours", value: 120 * ONE_MIN },
];

function FormFields() {
  const { control } = useFormContext<FormValues>();

  return (
    <Controller
      control={control}
      name="idleTimeout"
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <Select
          aria-label="Session timeout"
          {...field}
          selectedKey={field.value}
          onSelectionChange={(val) => field.onChange(val)}
          isInvalid={!!error}
          validationBehavior="aria"
        >
          <Description>
            Users will be automatically logged out after this amount of time.
          </Description>
          <SelectTrigger />
          <SelectList items={options}>
            {(item) => (
              <SelectItem id={item.value.toString()}>{item.label}</SelectItem>
            )}
          </SelectList>
          <FieldError>{error?.message}</FieldError>
        </Select>
      )}
    />
  );
}
